import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  ReactNode,
} from "react";

interface UserProfile {
  id: string;
  name: string;
  email: string;
  picture?: string;
  role?: string;
  createdAt?: string;
  updatedAt?: string;
  // 👆 Agrega aquí los campos que tu backend devuelva
}

interface ProfileContextType {
  loading: boolean;
  profile: UserProfile | null;
  error: string | null;
  refreshProfile: () => Promise<void>;
}

interface ProfileProviderProps {
  children: ReactNode;
}

const ProfileContext = createContext<any | undefined>(undefined);

const apiUrl = process.env.REACT_APP_API_URL;

export const ProfileUserProvider = ({ children }: ProfileProviderProps) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchProfile = useCallback(async () => {
    if (!isAuthenticated) return;

    setLoading(true);
    setError(null);

    try {
      const token = await getAccessTokenSilently();

      const response = await axios.get<any>(
        `${apiUrl}/api/v1/profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

     // console.log('rtest', response.data.response)

      setProfile(response.data.response);
    } catch (err: any) {
      console.error("Error al obtener el perfil:", err);
      setError(err.message || "Error al obtener el perfil");
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return (
    <ProfileContext.Provider
      value={{
        loading,
        profile,
        error,
        refreshProfile: fetchProfile,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

// ✅ Hook de acceso al contexto
export const useProfile = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error("useProfile debe usarse dentro de un ProfileUserProvider");
  }
  return context;
};
